module.exports = __webpack_public_path__ + "media/assets/images/flags/ls-bff46849646eb4a316a24f90d3ecb590.svg";